const RequestOptions = {
  requestRate: 'requestRate',
  requestUpdate: 'requestUpdate',
} as const;

const SortOptions = {
  WEEKLYAVAILABILITY: 'weeklyAvailability',
  YEARSOFEXPERIENCE: 'yearsOfExperience',
} as const;

const Filters = {
  PRACTICEAREA: 'practiceArea',
  SEARCH: 'search',
  SORT: 'sort',
  STATUS: 'status',
} as const;

const SearchableDateFormats = [
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'MM-DD-YY',
  'MM/DD/YY',
  'M/D/YY',
  'M-D-YY',
  'M/D/YYYY',
  'M-D-YYYY',
] as const;

export const MyBenchConst = {
  RequestOptions,
  SortOptions,
  Filters,
  SearchableDateFormats,
} as const;
